import { render, staticRenderFns } from "./customer-status.vue?vue&type=template&id=a8d63d40&"
import script from "./customer-status.vue?vue&type=script&lang=js&"
export * from "./customer-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports